/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationRelationShow } from '../../axios/organisationRelationShow'
import type {
	OrganisationRelationShowError,
	OrganisationRelationShowPathParams,
	OrganisationRelationShowResponse,
} from '../../types/OrganisationRelationShow'

export const organisationRelationShowQueryKey = (organisation: OrganisationRelationShowPathParams['organisation']) =>
	[{ url: '/organisations/:organisation', params: { organisation } }] as const

export type OrganisationRelationShowQueryKey = ReturnType<typeof organisationRelationShowQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationRelationController.php OrganisationRelationController::show */
export function organisationRelationShowQueryOptions(
	organisation: OrganisationRelationShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationRelationShowResponse,
		AxiosError<OrganisationRelationShowError>,
		OrganisationRelationShowResponse,
		OrganisationRelationShowQueryKey
	>({
		queryKey: organisationRelationShowQueryKey(organisation),
		queryFn: ({ signal }) => organisationRelationShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationRelationController.php OrganisationRelationController::show */
export function useOrganisationRelationShow<TSelectData = OrganisationRelationShowResponse>(
	organisation: OrganisationRelationShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationRelationShowResponse,
					AxiosError<OrganisationRelationShowError>,
					TSelectData,
					OrganisationRelationShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationRelationShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationRelationShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationRelationController.php OrganisationRelationController::show */
export function useOrganisationRelationShowSuspense<TSelectData = OrganisationRelationShowResponse>(
	organisation: OrganisationRelationShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationRelationShowResponse,
					AxiosError<OrganisationRelationShowError>,
					TSelectData,
					OrganisationRelationShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationRelationShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationRelationShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
